import * as fromDatatype from '../datatype-library/index';

export interface bl_prt_printable_format_image_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  file_item_guid: fromDatatype.GuidDataFieldInterface;
  image_code: fromDatatype.VarcharDatatypeInterface;
  image_name: fromDatatype.VarcharDatatypeInterface;
  image_type: fromDatatype.TextDatatypeInterface;
  sort_code: fromDatatype.TextDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_prt_printable_format_image_hdr_RowClass implements bl_prt_printable_format_image_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  file_item_guid: fromDatatype.GuidDataFieldInterface;
  image_code: fromDatatype.VarcharDatatypeInterface;
  image_name: fromDatatype.VarcharDatatypeInterface;
  image_type: fromDatatype.TextDatatypeInterface;
  sort_code: fromDatatype.TextDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}
